// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PopupTemplateHead_wrapper__1rG4x","p":"PopupTemplateHead_p__Gvpg0"};